import React from "react";
//#region components
import { Icon } from "components/common";
import { Grid } from "@mui/material";
//#endregion
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { AccountingDoneProps } from "models/propTypes/widgetProps";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const AccountingDone: React.FC<AccountingDoneProps> = (props) => {
  const { accountingCompletedUntil } = props;

  return (
    <Grid item container wrap={"nowrap"} className={cssExports.accountingStatus} direction="row" columnGap={3}>
      {/* For screen sizes > sm */}
      <Grid item container direction="column" display={{ md: "flex", xs: "none" }} md="auto" rowGap={"2px"}>
        <Grid item className={cssExports.accountingDoneUntil}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Accounting.AccountingDoneUntil)}
        </Grid>
        <Grid item container wrap="nowrap" direction="row" columnGap={1} alignItems="center">
          <Grid item className={cssExports.selectionIcon}>
            <Icon icon={IconDefinitionConstants.WCheckCanvas} />
          </Grid>
          <Grid item className={cssExports.accountingDoneDate}>
            {accountingCompletedUntil !== undefined
              ? LocalizationHelperInstance.getFormattedDate(accountingCompletedUntil)
              : ""}
          </Grid>
        </Grid>
      </Grid>
      {/* For screen sizes <= sm */}
      <Grid item container direction="row" display={{ md: "none", xs: "flex" }} wrap="nowrap" columnGap={1}>
        <Grid item className={cssExports.selectionIcon}>
          <Icon icon={IconDefinitionConstants.WCheckCanvas} />
        </Grid>
        <Grid item container xs columnGap={1} direction="row">
          <Grid item className={cssExports.accountingDoneUntil}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Accounting.AccountingDoneUntil)}
          </Grid>
          <Grid item className={cssExports.accountingDoneDate}>
            {accountingCompletedUntil !== undefined
              ? LocalizationHelperInstance.getFormattedDate(accountingCompletedUntil)
              : ""}
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        container
        direction="column"
        display={{ md: "flex", xs: "none" }}
        className={cssExports.accountingChecksContainer}
        md
        rowGap={"2px"}
      >
        <Grid item>
          <Icon icon={IconDefinitionConstants.WCheck} />
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Accounting.DocumentsAreBooked)}
        </Grid>
        <Grid item>
          <Icon icon={IconDefinitionConstants.WCheck} />
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Accounting.BankAccountsAreReconciled)}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AccountingDone;
